













































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaBanco from "@/components/notasCredito/Tabla.vue";
import FormularioBanco from "@/components/notasCredito/Formulario.vue";
import { DataFormularioNotaCredito } from "@/typings/components/notasCredito/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoBanco from "@/components/notasCredito/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  NotaCredito,
  NotasCredito,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/notasCredito";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";
import CargarBancosExcel from "@/components/excel/CargarBancos.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["notasCredito"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getNotasCredito: "notasCredito/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayNotasCredito: "notasCredito/getArray",
  }),
  methods: mapActions({
    setNotaCredito: "notasCredito/set",
    deleteNotaCredito: "notasCredito/delete",
    insertBatchNotasCredito: "notasCredito/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaBanco,
    FormularioBanco,
    InfoBanco,
    //BotonesCrud,
    MensajeEliminar,
    CargarBancosExcel,
    //TituloVista,
  },
})
export default class VistaNotasCredito extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  notaCredito: NotaCredito | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE BANCO?";
  dialogoCargarExcel = false;

  get notasCredito(): NotasCredito {
    return this.getNotasCredito;
  }

  get items(): Array<NotaCredito> {
    return this.getArrayNotasCredito;
  }

  clickItem(val: { id: string } | null): void {
    this.notaCredito = val ? (this.notasCredito as Record<string, NotaCredito>)[val.id] ?? null : null;
  }

  clickPlus(): void {
    this.notaCredito = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioNotaCredito): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setNotaCredito(doc);
    if (doc.id != this.notaCredito?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.notaCredito?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.notaCredito = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const notaCredito = this.notaCredito;
    if (!notaCredito?.id) {
      console.error("error id: ", notaCredito);
      return;
    }
    this.deleteNotaCredito(String(notaCredito.id));
    this.notaCredito = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(notaCredito: NotaCredito): void {
    if (!notaCredito.id) {
      console.error("error id: ", notaCredito);
      return;
    }
    const doc = this.notasCredito[notaCredito.id];
    if (doc) {
      this.notaCredito = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.notaCredito = null;
  }

  abrirDialogoFormulario(notaCredito: NotaCredito): void {
    if (!notaCredito.id) {
      console.error("error id: ", notaCredito);
      return;
    }
    const doc = this.notasCredito[notaCredito.id];
    if (doc) {
      this.notaCredito = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(notaCredito: NotaCredito): void {
    if (!notaCredito.id) {
      console.error("error id: ", notaCredito);
      return;
    }
    const doc = this.notasCredito[notaCredito.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.notaCredito = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.notaCredito = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.notaCredito = null;
  }
}
